import * as React from "react";
import {PrimaryModels} from "../../_definitions/styleteq";
import Style from "../../_data/models/Style";
import User from "../../_data/models/User";
import Shop from "../../_data/models/Shop";
import Booth from "../../_data/models/Booth";
import {clientModelName} from "../../_helpers/utils";
import * as _ from "lodash";
import * as pluralize from "pluralize";
import Special from "../../_data/models/Special";
import * as moment from "moment";
import SearchResult from "../../_data/models/SearchResult";

interface Props {
    result: SearchResult;
    model: PrimaryModels;
    viewItem: () => void;
    dependencies: {
        shop?: Shop;
        user?: User;
    };
}

const SearchResultItemComponent = (props: Props) => {
    const {result, model, viewItem, dependencies} = props;

    let image = "";
    let title = "";
    let description = "";
    let distance = result.distance;

    if (model instanceof User) {
        const user = model as User;
        image = user.profilePicture();
        title = user.username();
        description = user.completeAddress();
        if (!user.isProfessional) {
            distance = null;
            description = null;
        }
    } else if (model instanceof Shop) {
        const shop = model as Shop;
        image = shop.primaryPictureUrl;
        title = shop.name;
        description = shop.completeAddress();
        if(!dependencies.user.isProfessional)
            description = null;
    } else if (model instanceof Booth) {
        const booth = model as Booth;
        image = booth.primaryPictureUrl || dependencies.shop.primaryPictureUrl;
        title = dependencies.shop.name;
        description = `${booth.workstationCount} ${pluralize('booth', booth.workstationCount)} available`;
    } else if (model instanceof Special) {
        const special = model as Special;
        image = dependencies.user.profilePicture();
        title = special.title;
        description = `Ends on ${moment(special.endDate).format('MMMM D, YYYY h:m A')}`;
    } else if (model instanceof Style) {
        const style = model as Style;
        image = style.primaryPictureUrl;
        title = dependencies.user.name;
        description = style.tags.length ? style.tags.join(", ") : style.description;
    }

    if (dependencies.user && !dependencies.user.isProfessional)
        distance = null;

    return (
        <li>
            <div className="media-object">
                <div className="media-object-section flushed middle">
                    <div className="img-wrapper small-img-fit">
                        <img src={image}/>
                    </div>
                </div>
                <div className="media-object-section middle">
                    <div className="text-group">
                        <p>
                            <b>{title}</b>
                            {distance &&
                            <small className="ml-1">{result.distanceInMiles()} Miles</small>
                            }
                        </p>
                        <small className="subheader">{description}</small>
                    </div>
                </div>
            </div>
            <a className="button primary hollow pull-right" onClick={viewItem}>
                View {_.capitalize(clientModelName(model))}
            </a>
        </li>
    );
};
export default SearchResultItemComponent;


// WEBPACK FOOTER //
// ./app/client/search/components/SearchResultItemComponent.tsx